import React from "react";
import {FastField} from 'formik';
import SkeletonPlaceHolder from "../skeletonPlaceHolder/SkeletonPlaceHolder";
import CustomTextField from "../customTextField/CustomTextField";
import { useValidationSchemaContext } from "../editors/commons/editor/components/validateSchemaProvider/ValidationSchemaProvider ";

export interface IFormikCheckBoxProps {
  loading?: boolean;
  label?: any;
  name?: string;
  autoComplete?: string;
  placeholder?: string;
  onChange?: any;
}

const TextFieldCustomized = (props) => {
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name];
  const { IsRequired } = useValidationSchemaContext();
  const required = IsRequired(props.field.name);
  return <CustomTextField required={required} {...props} {...props.field} onChange={props.onChange || props.field.onChange} error={error}/>
}


const FormikTextField = (props: IFormikCheckBoxProps) => {
  if (props.loading) {
    return (<SkeletonPlaceHolder
      variant="text"
      width={300}
    />);
  } else {
    return (
      <FastField
        type="text"
        component={TextFieldCustomized}
        label={props.label}
        name={props.name}
        placeholder={props.placeholder}
        color="primary"
        autoComplete={props.autoComplete}
        onChange={props.onChange}
      />
    );
  }
};

FormikTextField.defaultProps = {};

export default React.memo(FormikTextField);
